import { Italic } from './italic.js'

export * from './italic.js'

export default Italic
